/**
 * /employee/:id (link cũ, bookmark) → hồ sơ People 2.
 * 20/10/2026: /people đã chuyển hướng sang /people2; đường dẫn hồ sơ là /people2/person/:id.
 */
import { Navigate, useParams } from 'react-router-dom';
export default function EmployeeRedirect() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={id ? `/people2/person/${id}` : '/people2'} replace />;
}
